import React, { FC } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { updateHeaderConfig } from '@reducers/details';

interface ProductionOrderDetailsNCFileEventsSetupProps {
  ncFileId: number | null;
}

const ProductionOrderDetailsNCFileEventsSetupComponent: FC<ProductionOrderDetailsNCFileEventsSetupProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFileId,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.SETUP, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileEventsSetup = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileEventsSetupComponent);

export { ProductionOrderDetailsNCFileEventsSetup };
